import { ServiceHandler } from '../../../utils/api.utils';
import type { PageDwellRequest } from '../types';

export const trackPageDwell = ServiceHandler<
  PageDwellRequest,
  { signal_id: string }
>({
  url: '/api/chat-agent/v1/signals/page-dwell',
  method: 'POST',
});
